import React, { useEffect, useState } from "react"
import { IMG } from "../../common/CONST"
import { IClientContractorAccountDto } from "../../../types/contractor/IClientContractorAccountDto"
import { SwiftPicker } from "../../common/element/fields/SwiftPicker"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { ISwift } from "../../../types/dict/ISwift"
import { CommonInput } from "../../common/element/fields/CommonInput"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { CurrencyPicker } from "../../common/element/fields/CurrencyPicker"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useParams } from "react-router-dom"

export const ContractorClientAccount: React.FC<{
  accounts: IClientContractorAccountDto[]
  setAccounts: (accounts: IClientContractorAccountDto[]) => void
  errors: IErrorModel | undefined
}> = ({ accounts, setAccounts, errors }) => {
  const params = useParams()
  const [currentAccountIndex, setCurrentAccountIndex] = useState(0)
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [confirmDeleteAccount, setConfirmDeleteAccount] = useState<IModalMessage>()
  // const errorIndexRegex = /requestBody\[(.*?)\]/

  useEffect(() => {
    if (accounts.length === 0) {
      let acc: IClientContractorAccountDto = {}
      setAccounts([...accounts, acc])
    }
  }, [accounts])

  const changeSwift = (swift: ISwift | undefined) => {
    if (swift) {
      let newAccounts = accounts.map((a, index) => {
        if (index === currentAccountIndex) {
          a.swift = swift.swift_code
          a.bankName = swift.bank_name
          return a
        } else {
          return a
        }
      })
      setAccounts(newAccounts)
    }
  }

  const changeAccount = (key: string, idx: number, value: string | undefined) => {
    let newAccounts = accounts
    newAccounts[idx][key as keyof IClientContractorAccountDto] = value
    setAccounts(newAccounts)
  }

  const addAccount = () => {
    for (const a of accounts) {
      if (!a.accountNumber || !a.swift || !a.currency || !a.bankName) {
        setModalMessage({ ...modalMessage, title: "Ошибка!", text: "Заполните уже добавленные счета" })
        return
      }
    }
    let acc: IClientContractorAccountDto = {
      id: undefined,
      bankName: undefined,
      swift: undefined,
      accountNumber: undefined,
      currency: undefined
    }
    const nextIdx = accounts.length
    setAccounts([...accounts, acc])
    setCurrentAccountIndex(nextIdx)
  }

  const deleteAccountConfirmation = (index: number) => {
    setConfirmDeleteAccount({
      ...confirmDeleteAccount,
      title: "Удаление счета",
      text: `Вы действительно хотите удалить счет ${index + 1}?`,
      _callback: deleteAccount,
      callbackValue: index
    })
  }

  const deleteAccount = (index: number) => {
    if (!index) return
    const acc = accounts[index]
    if (acc.id && params.id) {
      TrinityAPI.deleteClientContractorAccount(params.id, acc.id, response => {
        if (response.status === 200) {
          removeStateAccount(index)
        } else {
          setModalMessage({
            ...modalMessage,
            title: "Ошибка!",
            text: `Ошибка удаления счета: ${response.data.message}`
          })
        }
      })
    } else {
      removeStateAccount(index)
    }
  }

  const removeStateAccount = (index: number) => {
    let newAccounts = accounts.filter((a, idx) => {
      if (index !== idx) return a

      return false
    })
    setAccounts(newAccounts)
    setCurrentAccountIndex(0)
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <ModalConfirm message={confirmDeleteAccount} setMessage={() => setConfirmDeleteAccount(undefined)} />
      <li className="form-block-popup">
        <h4 className="heading-chapter">Счет</h4>
        <div className="flex-row-10 centred_row flex-wrap">
          {accounts.map((a, index) => (
            <button
              className={`btn ${index === currentAccountIndex ? "black-btn" : "grey-btn"} btn-bank-account`}
              key={index}
              onClick={() => setCurrentAccountIndex(index)}
            >
              Счет {index + 1}
              <img
                src={IMG.close_acc}
                alt=""
                className="close-account-img"
                onClick={() => deleteAccountConfirmation(index)}
              />
            </button>
          ))}
          <button className="btn-plus" onClick={addAccount} />
        </div>
        {accounts.map((a, index) => (
          <React.Fragment key={index}>
            <div className="flex-row-10 flex-wrap" style={{ display: index === currentAccountIndex ? "" : "none" }}>
              <SwiftPicker
                label={"SWIFT"}
                name={`requestBody[${index}].swift`}
                value={a.swift}
                errorModel={errors}
                _callback={changeSwift}
              />
              <CommonInput
                typeName={"text"}
                label={"IBAN"}
                placeholder={"Введите номер счета"}
                name={`requestBody[${index}].accountNumber`}
                value={a.accountNumber}
                errorModel={errors}
                _callback={e => changeAccount("accountNumber", index, e)}
              />
            </div>
            <div className="flex-row-10 flex-wrap" style={{ display: index === currentAccountIndex ? "" : "none" }}>
              <CommonInput
                typeName={"text"}
                label={"Банк"}
                placeholder={"Название банка"}
                name={`requestBody[${index}].bankName`}
                value={a.bankName}
                errorModel={errors}
                _callback={e => changeAccount("bankName", index, e)}
              />
              <CurrencyPicker
                label={"Валюта счета"}
                name={`requestBody[${index}].currency`}
                errorModel={errors}
                initValue={a.currency}
                _callback={e => changeAccount("currency", index, e)}
                clazzName={"fieldset-200"}
              />
            </div>
          </React.Fragment>
        ))}
      </li>
    </>
  )
}
